module.exports = __webpack_public_path__ + "assets/img/ty5.f2d4be22.jpg";